import React from 'react'

export default function SortArrowsIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.35155 13.2143V3.72656M6.7031 10.8626L4.35155 13.2143L2 10.8626" stroke="#64617E" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.6484 2.99863L11.6484 12.4863M9.2969 5.35028L11.6484 2.99863L14 5.35028" stroke="#64617E" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
